import React from 'react';
import './OutrTicketDetail.css';

const OutrTicketDetail = () => {
    return (
        <div className="outr-ticket-container">
            <div className="outr-ticket-content">
                {/* Header Title */}
                <header className="header-section">
                    <h1 className="header-title">
                        Your Tickets: RAW: Uncensored
                        Storytelling and live music
                    </h1>
                </header>

                {/* Logo Section */}
                <div className="logo-section">
                    <div className="main-logo-circle">
                        <img
                            src="/image/outr-ticket-logo.png"
                            alt="Outr Logo"
                            className="main-logo-img"
                        />
                    </div>
                    <div className="main-logo-text">
                        Trelawny,  your ticket <br /> is below
                    </div>
                </div>

                {/* Ticket Card */}
                <div className="ticket-card">
                    <h2 className="card-title">RAW: uncensored Storytelling and live music</h2>
                    <div className="event-image-container">
                        <img
                            src="/image/image-1.png"
                            alt="Event"
                            className="event-image"
                        />
                    </div>
                    <button className="open-button">Open Ticket in Outr</button>
                </div>

                {/* Info Section */}
                <div className="info-section">
                    <h3 className="section-label">Info</h3>
                    <div className="info-row">
                        <span className="info-key">Date & Time</span>
                        <span className="info-value">WED 31, DEC • 6:30 PM</span>
                    </div>
                    <div className="info-row">
                        <span className="info-key">Venue</span>
                        <span className="info-value">Camley Street Natural Park</span>
                    </div>
                    <div className="info-row">
                        <span className="info-key">Entry</span>
                        <span className="info-value">06:00 PM</span>
                    </div>
                </div>

                {/* Ticket Details Section */}
                <div className="details-section">
                    <h3 className="section-label">Ticket Details</h3>
                    <div className="info-row">
                        <span className="info-key">Tickets</span>
                        <span className="info-value">1 x OUTR at RAW</span>
                    </div>
                    <div className="info-row">
                        <span className="info-key">Ticket Price</span>
                        <span className="info-value">£100</span>
                    </div>
                    <div className="info-row">
                        <span className="info-key">Guest Name</span>
                        <span className="info-value">Trelawny Mackenzie</span>
                    </div>
                </div>

                {/* Report Banner */}
                <div className="report-banner">
                    <div className="report-header">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="M12 16h.01"></path>
                            <path d="M12 8v4"></path>
                        </svg>
                        Report a problem?
                    </div>
                    <p className="report-text">
                        Let's get you sorted. Check out our <br />
                        <span className="help-link">Help Center</span> and FAQs.
                    </p>
                </div>

                {/* Download Section */}
                <div className="download-section">
                    <h3 className="download-title">Download Outr</h3>
                    <div className="store-buttons">
                        <a href="https://play.google.com/store/apps/details?id=com.app.outr" target="_blank" rel="noopener noreferrer">
                            <img src="/play-store.svg" alt="Get on Google Play" style={{ width: '150px' }} />
                        </a>
                        <a href="https://apps.apple.com/us/app/outr/id6748447370" target="_blank" rel="noopener noreferrer">
                            <img src="/app-store.svg" alt="Download on App Store" style={{ width: '150px' }} />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OutrTicketDetail;
